import React, { useState, useEffect, useRef} from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useManualQuery, useMutation } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  Grid,
  Typography,
  Tooltip
} from "@mui/material";
import AlertPopup from "../components/AlertPopup.js";
import { WAITING_LIST_QUERY, DELETE_WAITIG_LIST_EMAIL_MUTATION } from "../graphQL/waitlist_qry";
import trashImg from "../assets/icons/trash.png";
import { styled } from "@mui/material/styles";
import AuthWrapper from "../AuthWrapper";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip
    arrow
    {...props}
    classes={{ popper: className }}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))(({ theme }) => ({
  "& .MuiTooltip-tooltip": {
    display: "flex",
    background: "rgba(97, 97, 97, 0.9)",
    color: "#fff",
    borderRadius: 4,
    fontSize: 10,
    fontWeight: 500,
  },
}));

const RootDiv = styled("div")({
    marginRight: "8rem",
    textAlign: "center",
    padding: 2,
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    //  minWidth: "500px",
});

const ContainerDiv = styled("div")({
    padding: 32,
    marginBottom: "5rem",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
});

export default function AdminWaitlist() {
  const navigate = useNavigate();
  const [waitingList, setWaitingList] = useState([]);
  const [isPaginationMenuOpen, setIsPaginationMenuOpen] = useState(false);
  const paginationSelectRef = useRef(null);
  const paginationMenuRef = useRef(null);
  // Alert popup state
  const [alertPopup, setAlertPopup] = useState({
    open: false,
    id: null,
  });

  const formatter = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // change to false if you prefer 24h format
  });

  const dayFormat = (day) => {
      const dayDate = new Date(day);
      return formatter.format(dayDate);
  };

  const [fetchWaitingList] = useManualQuery(WAITING_LIST_QUERY, {
    fetchPolicy: "network-only",
  });
    const [deleteWaitListEmailMutation] = useMutation(DELETE_WAITIG_LIST_EMAIL_MUTATION, {
    fetchPolicy: "network-only",
  });
  
  function checkDeleteStatus(row) {
    setAlertPopup({
      open: true,
      id: row.id,
    });
  }

  const getWaitingList = async () => {
    const {
      loading: waitingListLoading,
      error: waitingListError,
      data: waitingListData,
    } = await fetchWaitingList();

    if (!waitingListLoading && waitingListData && waitingListData.waitingList) {
      setWaitingList(waitingListData.waitingList);
    }
    if(waitingListError){
      console.log(waitingListError)
    } else {
    }
  };

  useEffect(() => {
    (() => getWaitingList())();
  }, []);

  const columns = [
    {
      field: "email",
      headerName: "Email Address",
      minWidth: 170,
      flex: 1,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "dateJoined",
      headerName: "Date Joined",
      minWidth: 120,
      flex: 1,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
{
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var deleteFilter = "none";        
        var deleteOpacity = 1;        
        var deleteCursor = "pointer";
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >             
             <StyledTooltip title="Delete this email" placement="top">
                  <img
                    alt="Delete this email"
                    style={{
                      paddingRight: 15,
                      cursor: deleteCursor,
                      paddingBottom: 8,
                      height: "32px !important",
                      weight: "32px !important",
                      filter: deleteFilter,
                      opacity: deleteOpacity,
                    }}
                    src={trashImg}
                    onClick={() => checkDeleteStatus(rows.row)}
                  />
                </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const rows = waitingList.map(item => ({
    id: item.waitingListId,
    email: item.email,
    dateJoined: dayFormat(item.submitDate),
  }));

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          sx={{
            pt: 0.5,
            pb: 0.75,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",            
          }}
        >
          <Grid item xs={10} sx={{ textAlign: "center" }}>
            <Typography variant="h1" sx={{ fontSize: 20, pl: 12.5, fontWeight: 500, fontFamily: "Roboto, Helvetica, Arial, sans-serif" }}>
              Wait List
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  const deleteWaitListEmail = async id => {
    const {
      loading: loadingEmailDelete,
      error: errorEmailDelete,
      data: dataEmailDelete,
    } = await deleteWaitListEmailMutation({
      variables: {
        id: parseInt(id),
      },
    });
    if (!loadingEmailDelete && dataEmailDelete && dataEmailDelete.deleteWaitingListEmail) {      
      getWaitingList();
    }
    if (errorEmailDelete) {
      if (errorEmailDelete.graphQLErrors[0].message === "Signature has expired")
        navigate(`/ie/signin`);
      else alert(errorEmailDelete.graphQLErrors[0].message);
    }
  };
  
  useEffect(() => {
    const handleScroll = (event) => {
      if (isPaginationMenuOpen) {
        const isScrollingInsideDropdown =
          (paginationMenuRef.current &&
            paginationMenuRef.current.contains(event.target)) ||
          (paginationSelectRef.current &&
            paginationSelectRef.current.contains(event.target));

        if (!isScrollingInsideDropdown) {
          setIsPaginationMenuOpen(false);
        }
      }
    };

    if (isPaginationMenuOpen) {
      document.addEventListener("scroll", handleScroll, true);
    }

    return () => {
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [isPaginationMenuOpen]);
  
  const handleCancelAction = () => {
    setAlertPopup({ open: false, id: null });
  };

  return (
  <AuthWrapper>
    <RootDiv>      
      <title>R3PLAY - Waitlist Management – Admin</title>       
        <ContainerDiv>
        <DataGrid
          sx={{
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none !important",
            },
            "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator":
              {
                display: "none",
              },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 700,
              fontSize: 12,
            },
          }}
          columns={columns}
          rows={rows}
          showCellRightBorder={true}
          slots={{ toolbar: DataGridTitle }}
          getRowId={row => row.id}
          autoHeight={true}
          experimentalFeatures={{ newEditingApi: true }}
          pagination
          pageSizeOptions={[10, 20, 50]}   // user can select page size
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 10 } }, // default to 10 rows
            sorting: {
              sortModel: [{ field: "name", sort: "asc" }],
            },
          }}
          slotProps={{
          pagination: {
            SelectProps: {
              open: isPaginationMenuOpen,
              onOpen: () => setIsPaginationMenuOpen(true),
              onClose: () => setIsPaginationMenuOpen(false),
              ref: paginationSelectRef,
              MenuProps: {
                PaperProps: {
                  ref: paginationMenuRef,
                },
              },
            },
          },
        }}
        />
        {/* Alert Popup */}
        <AlertPopup
          open={alertPopup.open}
          onClose={handleCancelAction}
          title={"Delete"}
          message={"Are you sure you want to delete this record?"}
          confirmText={"DELETE"}
          onConfirm={() => {
            deleteWaitListEmail(alertPopup.id);
            setAlertPopup({ open: false, id: null });
          }}
          onCancel={handleCancelAction}
        />
      </ContainerDiv>
    </RootDiv>
  </AuthWrapper>
  );
}
